import { render, staticRenderFns } from "./RemoveConfirmationModal.vue?vue&type=template&id=29ddf8f8&"
import script from "./RemoveConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./RemoveConfirmationModal.vue?vue&type=script&lang=js&"
import style0 from "./RemoveConfirmationModal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports